import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  ActivateCodeRequest,
  ActivateCodeResponse,
  RegisterUserRequest,
  RegisterUserResponse,
} from '@tsin-core/models/guest.model';
import { environment } from '@tsin-env/environment';
import { Observable } from 'rxjs';

// `environment.apiUrl` already ends in `/api` (dev/stage/prod) so this resolves to
// {apiUrl}/guests/activate => .../api/guests/activate, matching the other http services.
const GUEST_ACTIVATE_URL = `${environment.apiUrl}/guests/activate`;
const USER_REGISTER_URL = `${environment.apiUrl}/user/register`;

@Injectable({
  providedIn: 'root',
})
export class GuestService {
  private http: HttpClient = inject(HttpClient);

  // Activate a guest profile with an activation code.
  activate(payload: ActivateCodeRequest): Observable<ActivateCodeResponse> {
    return this.http.post<ActivateCodeResponse>(GUEST_ACTIVATE_URL, payload);
  }

  // Complete sign-up by registering the user profile captured in the stepper.
  register(payload: RegisterUserRequest): Observable<RegisterUserResponse> {
    return this.http.post<RegisterUserResponse>(USER_REGISTER_URL, payload);
  }
}
